import React, { FC, lazy, Suspense, useMemo } from "react";

import { PopupTypes } from "./../../../store/types/Popup";
import { ReactComponent as Loading } from "./../../../assets/images/animations/spinner.svg";

import styles from "./styles.module.scss";

interface IProps {
    callback: null | Function;
    onClose: () => void;
    current: PopupTypes | null;
    initialText?: string
}

function renderLazyPopup(name: PopupTypes) {
    return lazy(() => import("./../" + name));
}

const Content: FC<IProps> = ({ callback, current, onClose, initialText }) => {
    return useMemo(
        () => (
            <Suspense fallback={<Loading className={styles.loading} />}>
                {current &&
                    React.createElement(renderLazyPopup(current), {
                        callback,
                        onClose,
                        initialText
                    })}
            </Suspense>
        ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [callback, current, initialText],
    );
};

export default Content;
